import { render, staticRenderFns } from "./AbkRadioButtonsQuestion.vue?vue&type=template&id=7bc4296e&scoped=true&"
import script from "./AbkRadioButtonsQuestion.vue?vue&type=script&lang=js&"
export * from "./AbkRadioButtonsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AbkRadioButtonsQuestion.vue?vue&type=style&index=0&id=7bc4296e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4296e",
  null
  
)

export default component.exports